import { useState } from 'react';
import { Menu, X, ArrowRight } from 'lucide-react';
import { Container, Logo } from './shared';

const LINKS = [
  ['Features', '#features'], ['How it works', '#how-it-works'], ['Security', '#security'],
  ['Pricing', '#pricing'], ['FAQ', '#faq'], ['Blog', '/blog'],
];

export const LandingNav = ({ user, onLogin, onStart, announcement, onCloseAnnouncement }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      {announcement && (
        <div className="relative bg-[#E06D53] text-white text-center text-xs sm:text-sm py-2 px-10" data-testid="announcement-bar">
          <span className="ld-mono tracking-wide">NEW</span> · Razorpay billing, GPS field attendance & voice CRM are live.
          <a href="#features" className="underline underline-offset-2 ml-2 font-medium">See what's new →</a>
          <button onClick={onCloseAnnouncement} className="absolute right-3 top-1/2 -translate-y-1/2 p-1 hover:bg-white/15 rounded" aria-label="Dismiss" data-testid="announcement-close"><X className="w-3.5 h-3.5" /></button>
        </div>
      )}
      <header className="ld-nav" data-testid="landing-nav">
        <Container className="h-16 flex items-center justify-between">
          <a href="/" className="flex items-center gap-2"><Logo /></a>
          <nav className="hidden lg:flex items-center gap-1">
            {LINKS.map(([label, href]) => (
              <a key={label} href={href} className="ld-nav-link" data-testid={`nav-${label.toLowerCase().replace(/\s+/g, '-')}`}>{label}</a>
            ))}
          </nav>
          <div className="hidden lg:flex items-center gap-3">
            {user ? (
              <button onClick={onStart} className="ld-btn-primary !py-2.5 !px-5" data-testid="go-to-dashboard-btn">Dashboard <ArrowRight className="w-4 h-4" /></button>
            ) : (
              <>
                <button onClick={onLogin} className="ld-nav-link" data-testid="nav-login-link">Log in</button>
                <button onClick={onStart} className="ld-btn-primary !py-2.5 !px-5" data-testid="nav-get-started-btn">Get started</button>
              </>
            )}
          </div>
          <button className="lg:hidden p-2 text-slate-200" onClick={() => setOpen(!open)} aria-label="Menu" data-testid="mobile-menu-toggle">
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </Container>
        {open && (
          <div className="lg:hidden border-t border-white/10 bg-[#08090A]/95 backdrop-blur-xl" data-testid="mobile-menu">
            <Container className="py-4 flex flex-col gap-1">
              {LINKS.map(([label, href]) => <a key={label} href={href} onClick={() => setOpen(false)} className="ld-nav-link py-3 text-base">{label}</a>)}
              <div className="flex gap-3 pt-3 border-t border-white/10 mt-2">
                <button onClick={onLogin} className="ld-btn-ghost flex-1" data-testid="mobile-login-btn">Log in</button>
                <button onClick={onStart} className="ld-btn-primary flex-1" data-testid="mobile-get-started-btn">Get started</button>
              </div>
            </Container>
          </div>
        )}
      </header>
    </>
  );
};
